// src/auth/RegisterPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../layout/PublicHeader';
import PublicFooter from '../layout/PublicFooter';
import { apiFetch } from '../api/api';
import '../App.css';

export default function RegisterPage() {
  const [mode, setMode] = useState('createPrimaryOrg'); // createPrimaryOrg | joinOrg | createChildOrg | userOnly
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [organization, setOrganization] = useState('');
  const [parentOrgId, setParentOrgId] = useState('');
  const [parentJoinCode, setParentJoinCode] = useState('');
  const [joinOrgId, setJoinOrgId] = useState('');
  const [inviteToken, setInviteToken] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      let body;

      if (mode === 'createPrimaryOrg') {
        if (!organization.trim()) { setError('Organization name is required'); return; }
        body = {
          email,
          password,
          flow: 'create_org',
          org: { name: organization.trim(), canCreateChildOrgs: false }
        };
      } else if (mode === 'joinOrg') {
        if (!joinOrgId.trim()) { setError('Organization ID is required'); return; }
        body = {
          email,
          password,
          flow: 'join_org',
          join: { orgId: joinOrgId.trim(), roles: ['org:editor'], inviteToken: inviteToken || undefined }
        };
      } else if (mode === 'createChildOrg') {
        if (!organization.trim() || !parentOrgId.trim()) {
          setError('Child org name and parent org ID are required'); return;
        }
        // NOTE: this posts parentOrgId; ensure your registerComposite handles it (can be a no-op for now).
        body = {
          email,
          password,
          flow: 'create_org',
          org: {
            name: organization.trim(),
            orgType: 'child',
            parentOrgId: parentOrgId.trim(),
            parentJoinCode: parentJoinCode || undefined,
            canCreateChildOrgs: false
          }
        };
      } else {
        // userOnly
        body = { email, password, flow: 'user_only' };
      }

      const res = await apiFetch('/auth/register-composite', { method: 'POST', body });
      if (!res.ok) {
        const txt = await res.text();
        setError(txt || 'Registration failed');
        return;
      }

      const { accessToken, refreshToken } = await res.json();
      localStorage.setItem('accessToken', accessToken);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);

      // seed active org from token so X-Org-Id goes out on first request
      const payload = JSON.parse(atob(accessToken.split('.')[1]));
      if (payload.orgId) localStorage.setItem('activeOrgId', payload.orgId);

      window.location.assign('/admin');
    } catch (err) {
      setError(err?.message || 'Something went wrong');
    }
  };

  return (
    <div>
      <PublicHeader />
      <h2>Register</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>{success}</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <label><input type="radio" name="mode" value="createPrimaryOrg" checked={mode==='createPrimaryOrg'} onChange={e=>setMode(e.target.value)} /> Create a new organization</label><br/>
          <label><input type="radio" name="mode" value="joinOrg" checked={mode==='joinOrg'} onChange={e=>setMode(e.target.value)} /> Join an existing organization</label><br/>
          <label><input type="radio" name="mode" value="createChildOrg" checked={mode==='createChildOrg'} onChange={e=>setMode(e.target.value)} /> Create a child (event) organization</label><br/>
          <label><input type="radio" name="mode" value="userOnly" checked={mode==='userOnly'} onChange={e=>setMode(e.target.value)} /> Just create my user account</label>
        </div>

        <label>Email:</label>
        <input name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <label>Password:</label>
        <input name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />

        {mode === 'createPrimaryOrg' && (
          <>
            <label>Organization Name:</label>
            <input name="organization" value={organization} onChange={e=>setOrganization(e.target.value)} required />
          </>
        )}

        {mode === 'joinOrg' && (
          <>
            <label>Invite Token (optional):</label>
            <input name="inviteToken" value={inviteToken} onChange={e=>setInviteToken(e.target.value)} />
            <label>Organization ID:</label>
            <input name="joinOrgId" value={joinOrgId} onChange={e=>setJoinOrgId(e.target.value)} required />
          </>
        )}

        {mode === 'createChildOrg' && (
          <>
            <label>Child Organization Name:</label>
            <input name="childOrganization" value={organization} onChange={e=>setOrganization(e.target.value)} required />
            <label>Parent Organization ID:</label>
            <input name="parentOrgId" value={parentOrgId} onChange={e=>setParentOrgId(e.target.value)} required />
            <label>Parent Verification Code (if required):</label>
            <input name="parentJoinCode" value={parentJoinCode} onChange={e=>setParentJoinCode(e.target.value)} />
          </>
        )}

        <button type="submit">Register</button>
      </form>

      <div style={{ marginTop: 12 }}>
        <Link to="/login">Login</Link>
      </div>

      <PublicFooter />
    </div>
  );
}
